import { RegulationStatus } from '@vendasta/protos/sms/v2/enums';
import { RegistrationStage } from '../a2p-registration/a2p-registration.constants';

export function getRegistrationStageFromRegulationStatus(status: RegulationStatus): RegistrationStage {
  switch (status) {
    case RegulationStatus.REGULATION_STATUS_APPROVED:
      return RegistrationStage.RegistrationComplete;
    case RegulationStatus.REGULATION_STATUS_PENDING_REVIEW:
      return RegistrationStage.ReviewingInfo;
    case RegulationStatus.REGULATION_STATUS_REJECTED:
      return RegistrationStage.DataError;
    case RegulationStatus.REGULATION_STATUS_UNSPECIFIED:
    default:
      return RegistrationStage.NotSubmitted;
  }
}

export interface RegulationState {
  regulationStatus: RegulationStatus;
  registrationStage: RegistrationStage;
}

export function formatDateForBackend(date: Date | string): string {
  if (!date) return '';
  if (typeof date === 'string') return date;
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}

export function parseDateFromBackend(value: string | undefined): Date | string {
  if (!value) return '';
  const [y, m, d] = value.split('-').map(Number);
  if (!y || !m || !d) return value;
  return new Date(y, m - 1, d);
}
